<template>
	<v-container fluid class="live-body">
    <v-row class="contact-body">
      <v-card
      class="mx-auto contact"
      max-width="80%"
      tile
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="contact-label">
              <label>Facebook</label>
            </v-list-item-title>
            <v-list-item-subtitle>
              <a 
                href="https://www.facebook.com/profile.php?id=61573658180740" 
                target="_blank" 
                rel="noopener noreferrer" 
                class="contact-details"
              >
                <v-avatar size="100">
                  <v-img src="../assets/images/contact_image.jpg" alt="Circular Image"></v-img>
                </v-avatar>
                Master ng Gradas
              </a>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="contact-number-details">
          <v-list-item-content>
            <v-list-item-title class="contact-label">
              <label>Contact Number</label>
            </v-list-item-title>
            <v-list-item-subtitle>
              <div class="contact-details">
                +639272898313
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="contact-number-details">
          <v-list-item-content>
            <v-list-item-title class="contact-label">
              <label>Viber</label>
            </v-list-item-title>
            <v-list-item-subtitle>
              <div class="contact-details">
                +639272898313
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-row>

	</v-container>
</template>

<script>
	export default {
		name: 'ContactUs',

		data: () => ({
		}),
	}
</script>

<style scoped>
.contact {
  text-align: center;
  margin: 10%;
  font-weight: bold;
  background-color: rgba(0,0,0,0.0);
}
.contact-label {
  margin-bottom:20px;
  color: rgb(96, 102, 212);

}

.contact-details {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

.contact-number-details {
  margin-top:20px;
}

.live-body {
	background-color: rgba(0, 0, 0, 0.5);
	/* color:white; */
}
</style>
